import { useEffect } from 'react';

import { useI18nContext } from '../hooks/contexts/i18n.context';
import * as Style from '../styles/pages/styles.close';

const Close = () => {
  const { translate } = useI18nContext();

  useEffect(() => {
    window.close();
  }, []);

  return (
    <Style.Container id="not-found-page-container">
      <Style.Header id="not-found-page-header">{translate(['INFORMATION', 'FACIAL_DONE'])}</Style.Header>
      <Style.Text id="not-found-page-text">{translate(['INFORMATION', 'FACIAL_DONE_MESSAGE'])}</Style.Text>
    </Style.Container>
  );
};

export default Close;
